// node_modules/@brandboostinggmbh/painless/dist/index.js
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a;
var _b;
function pascalCaseToKebabCase(str) {
  return str.replace(/([A-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function defineElement(value) {
  return function(target) {
    const elementName = value || pascalCaseToKebabCase(target.name);
    window.customElements.define(elementName, target);
  };
}
var globalOn = (eventType) => {
  return (target, _propertyKey, descriptor) => {
    target._events = target._events ?? [];
    target._events.push({ func: descriptor.value, type: eventType, global: true });
  };
};
function liquidValue(customPropertyKey) {
  return function(target, propertyKey) {
    const getter = function() {
      const raw = this.getAttribute(`data-param-${(customPropertyKey ?? propertyKey).replace(/\./g, "___")}`);
      function htmlDecode(input) {
        const doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
      }
      try {
        return JSON.parse(htmlDecode(raw ?? "") ?? "null");
      } catch (e) {
        console.warn("couldnt read liquidValue", e);
        return void 0;
      }
    };
    Object.defineProperty(target, propertyKey, {
      get: getter
    });
    target._liquidValues = [...target._liquidValues ?? [], customPropertyKey ?? propertyKey];
  };
}
var on = (eventType, selector) => {
  return (target, _propertyKey, descriptor) => {
    target._events = target._events ?? [];
    target._events.push({ selector, func: descriptor.value, type: eventType });
  };
};
var onClick = (selector) => {
  return on("click", selector);
};
function param(customPropertyKey) {
  return liquidValue(customPropertyKey);
}
var query = (selector) => {
  return function(target, propertyKey) {
    const getter = function() {
      return this.querySelector(selector);
    };
    Object.defineProperty(target, propertyKey, {
      get: getter
    });
  };
};
var queryAll = (selector) => {
  return function(target, propertyKey) {
    const getter = function() {
      return Array.from(this.querySelectorAll(selector));
    };
    Object.defineProperty(target, propertyKey, {
      get: getter
    });
  };
};
var EventManager = class {
  constructor() {
    __publicField(this, "eventTargets", []);
  }
  on(type, func) {
    this.eventTargets.push(
      {
        type,
        func
      }
    );
  }
  emit(type, data) {
    this.eventTargets.forEach(
      ({ type: t, func }) => {
        if (t === type) {
          func(data);
        }
      }
    );
  }
};
var PainlessElement = class extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "_events", this._events);
    __publicField(this, "_state", {});
    __publicField(this, "_liquidValues", []);
    __publicField(this, "_eventManager", new EventManager());
    this._events;
    this._registerEventListeners();
  }
  get type() {
    return "PAINLESS";
  }
  on(type, func) {
    this._eventManager.on(type, func);
  }
  emit(type, data) {
    this._eventManager.emit(type, data);
    this.dispatchEvent(new CustomEvent(type, { detail: data }));
  }
  _registerEventListeners() {
    const events = this._events ?? [];
    for (const { selector, type, func, global } of events) {
      const wrapperTarget = global ? document : this;
      const targets = selector ? wrapperTarget.querySelectorAll(selector) : [wrapperTarget];
      targets.forEach((t) => {
        t.addEventListener(type, (evt) => {
          func.call(this, t, evt);
        });
      });
    }
  }
};
var SectionElement = class extends PainlessElement {
  get type() {
    return "SECTION";
  }
  constructor() {
    super();
  }
};
var SnippetElement = class extends PainlessElement {
  constructor() {
    super();
    __publicField(this, "_params", {});
  }
  get type() {
    return "SNIPPET";
  }
};
var GlobalEvents = class {
  static emit(type, data) {
    document.dispatchEvent(new CustomEvent(type, { detail: data }));
  }
  static on(type, func) {
    document.addEventListener(type, func);
  }
};
var Cart = class {
  constructor() {
    __publicField(this, "baseUrl", `${(_b = (_a = window == null ? void 0 : window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root}`);
    __publicField(this, "evt", new EventManager());
  }
  on(type, func) {
    this.evt.on(type, func);
  }
  emit(type, data) {
    this.evt.emit(type, data);
    GlobalEvents.emit(`cart:${type}`, data);
  }
  async fetch() {
    const res = await fetch(`${this.baseUrl}cart.js`, { credentials: "same-origin" });
    return res.json();
  }
  async updateLineItem(keyOrId, quantity) {
    var _a2;
    const response = await this.fetch();
    const lineItems = response.items;
    const item = lineItems == null ? void 0 : lineItems.find((item2) => item2.id == keyOrId || item2.key == keyOrId);
    const entries = [[keyOrId, quantity]];
    if (item != null && ((_a2 = item.properties) == null ? void 0 : _a2._unique) != null) {
      const findAddons = lineItems == null ? void 0 : lineItems.filter((i) => {
        var _a3, _b2;
        return ((_a3 = i.properties) == null ? void 0 : _a3._unique) == ((_b2 = item.properties) == null ? void 0 : _b2._unique) && i.id != item.id;
      });
      entries.push(...findAddons.map((i) => [i.key, quantity]));
    }
    await fetch(
      `${this.baseUrl}cart/update.js`,
      {
        method: "POST",
        body: JSON.stringify({
          updates: Object.fromEntries(entries)
        }),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    );
    this.evt.emit("updated");
  }
  async removeLineItem(key) {
    await this.updateLineItem(key, 0);
  }
  async updateCartAttributes(attributes) {
    await fetch(
      `${this.baseUrl}cart/update.js`,
      {
        method: "POST",
        body: JSON.stringify({
          attributes
        }),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    );
    this.evt.emit("updated");
  }
  async addItem(...items) {
    let normalizedItems = items.map(
      (item) => {
        let id;
        let quantity = 1;
        let properties;
        if (typeof item === "number") {
          id = item;
        } else if (typeof item === "string") {
          id = parseInt(item);
        } else {
          id = item.id;
          quantity = item.quantity ?? 1;
          properties = item.properties;
        }
        return {
          id,
          quantity,
          properties
        };
      }
    );
    const result = await fetch(
      `${this.baseUrl}cart/add.js`,
      {
        method: "POST",
        body: JSON.stringify({ "items": normalizedItems }),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    );
    if (result.status >= 400) {
      if (result.status == 422) {
        const error = await result.json();
        return error;
      }
      try {
        const error = await result.json();
        return error;
      } catch (e) {
        return { status: result.status, description: result.statusText };
      }
    }
    this.evt.emit("updated");
  }
};
var SectionRenderer = class {
  static async renderSection(sectionId) {
    const url = new URL(window.location.href);
    url.searchParams.set("sections", sectionId);
    const response = await fetch(url);
    const data = await response.json();
    return data[sectionId];
  }
};
var Theme = class {
};
__publicField(Theme, "Cart", new Cart());
var wait = (ms) => new Promise((res) => setTimeout(() => res(), ms));
var Debounce = class {
  static debounce(callback, wait2) {
    let timeoutId = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback(...args);
      }, wait2);
    };
  }
};

export {
  defineElement,
  globalOn,
  liquidValue,
  on,
  onClick,
  param,
  query,
  queryAll,
  SectionElement,
  SnippetElement,
  GlobalEvents,
  SectionRenderer,
  Theme,
  wait,
  Debounce
};
